import React from "react";
import Updater from "./updater";
import QuotesPage from "./QuotesPage";
import { useAppSelector } from "hooks/redux";
import { Spin } from "antd";

const QPage = () => {
    const { selectedRobotId } = useAppSelector((state) => state.robots);

    return (
        <>
            {selectedRobotId == null ? (
                <Spin />
            ) : (
                <>
                    <QuotesPage key={`-${selectedRobotId}`} />
                    <Updater />
                </>
            )}
        </>
    );
};

export default QPage;
